import URI from 'urijs'

import {API_BASE} from 'shared/constants/Api'

export const FILE_STORAGE_UPLOAD = () => { return URI(`${API_BASE}/api/v2/file_storage/`) }
export const FILE_STORAGE_DELETE = ({id}) => { return URI(`${API_BASE}/api/v2/file_storage/${id}/`) }
export const FILE_UPLOAD = ({parentType, ...params}) => { return URI(`${API_BASE}/api/files/${parentType}/`).addSearch(params) }
export const FILE_DELETE = ({parentType, id, ...params}) => { return URI(`${API_BASE}/api/files/${parentType}/${id}/`).addSearch(params) }
